import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { MappingtypeComponent } from '../../mappingtype/mappingtype.component';
import { VaultObjectgroupService } from '../../vaultobject-popup-screen/vault-objectgroup.service';
import { tap } from 'rxjs/operators';

export interface sourcedataextractionqueries{
  edata:any;
}


@Component({
    selector: 'app-source-data-extraction-queries-popup',
    templateUrl: './source-data-extraction-queries-popup.component.html',
    styleUrls: ['./source-data-extraction-queries-popup.component.scss'],
    standalone: false
})
export class SourceDataExtractionQueriesPopupComponent implements OnInit {

 backgroundColorButton;
    FormValid: FormGroup;
    updatedData;
    uploadId;
    name;
    validation_messages: any;
    mappingtypename
    buttonName
    idColumn
    formValidCheckbox: UntypedFormGroup;
    isCheckboxSelected=false;
    showCreateAnother=true;
     objectGroupData:any=[]
     selectedGroup:any
    sqlscripts__j = {
      'sqlscriptid__j':'','sqlscript__j':'','queryexecutiontype__j':'','tenantid':'','sourceconnectionstring__j':'','sourcetype__j':'','filename__j':'','executionorder__j':'',
      'attachmentquery__j':'','extractiontype__j':'','isExecutable__j':'','objectgroupname':'','setssplitrequired':'','groupextractiontype':'',
      'automatically_formate':'','formated_sqlscript__j':'','objectname':'','objectgroupid':''
    }
  ObjectsData: any;
    _inputCtrl: FormControl = new FormControl();
  dataSourceName: any=[];
  dataSourceType: any=[];
  queryExecutionType: any=[];
    constructor(private commonservice: CommonService, public dialogRef:MatDialogRef<MappingtypeComponent>,private validation:validationmethod,private localstorage:LocalStorageSettingsService,
      private errormessage:ErrorMessages,private spinner: NgxUiLoaderService,private snackbar:MatSnackBar, @Inject(MAT_DIALOG_DATA) public data: sourcedataextractionqueries,private fb: UntypedFormBuilder,
       private vaultObjectService: VaultObjectgroupService
    ) {
       this.validation_messages = this.errormessage.sqlscripts;
     }
  /*
  Author- Venkata Shyam
  07/11/2025
  For creation of  source-data-extraction-queries popup screen
*/
    ngOnInit(): void {
      const workSpaceId=this.localstorage.getSettings("WorkspaceId")
      console.log(workSpaceId)
      this.commonservice.getDataSourceName(workSpaceId).subscribe(result => {
      console.log(result);
      this.dataSourceName = result;
      });
      this.commonservice.getlookupVauleByLookUpType("Query Execution Type").subscribe(result => {
      console.log(result);
      this.queryExecutionType = result;
      });
       const dnsId=this.localstorage.getSettings("dnsName")
      this.buttonName = 'Save'
      console.log( this.data.edata)
      this.formvalidations();
      this.getObjectGroup$();
      this.updatedData = this.data.edata
      if(this.updatedData.sqlscriptid__j != undefined){
        this.buttonName = 'Update'
        this.showCreateAnother = false;
        console.log("sqlscriptid__j",this.updatedData.sqlscriptid__j)
        // this.FormValid.get('mappingtypename')?.setValue(this.updatedData.mappingTypeName);
        this.sqlscripts__j.sqlscriptid__j = this.updatedData.sqlscriptid__j
        this.sqlscripts__j.sqlscript__j = this.updatedData.sqlscript__j
        this.sqlscripts__j.queryexecutiontype__j = this.updatedData.queryexecutiontype__j
        this.sqlscripts__j.sourceconnectionstring__j = this.updatedData.sourceconnectionstring__j
        this.sqlscripts__j.sourcetype__j = this.updatedData.sourcetype__j
        this.sqlscripts__j.filename__j = this.updatedData.filename__j
        this.sqlscripts__j.executionorder__j = this.updatedData.executionorder__j
        this.sqlscripts__j.attachmentquery__j = this.updatedData.attachmentquery__j
        this.sqlscripts__j.extractiontype__j = this.updatedData.extractiontype__j
        this.sqlscripts__j.isExecutable__j = this.updatedData.isExecutable__j
        this.sqlscripts__j.objectgroupname = this.updatedData.objectgroupname
        this.sqlscripts__j.setssplitrequired = this.updatedData.setssplitrequired
        this.sqlscripts__j.groupextractiontype = this.updatedData.groupextractiontype
        this.sqlscripts__j.automatically_formate = this.updatedData.automatically_formate
        this.sqlscripts__j.formated_sqlscript__j = this.updatedData.formated_sqlscript__j
        this.sqlscripts__j.objectname = this.updatedData.objectname
        this.sqlscripts__j.objectgroupid = this.updatedData.objectgroupid
        this.selectedGroup = this.updatedData.objectgroupid
        this.commonservice
    .retrieveObjectsBasedOnObjectGroupNameBasedOnTenantId(dnsId, this.updatedData.objectgroupname)
    .subscribe((res: any) => {
      this.ObjectsData = res;
      
        console.log('Object group:', this.updatedData.objectgroupname);
    console.log('ObjectsData:', this.ObjectsData);
    console.log('Object IDs from backend:', this.ObjectsData.map(o => o.id));
    console.log('Selected IDs:', this.updatedData.objectname);
    
    if (this.updatedData.objectname && this.ObjectsData?.length > 0) {
      const selectedIds = this.updatedData.objectname
        .replace(/\[|\]/g, '')
        .split(',')
        .map(id => Number(id.trim()))
        .filter(id => !isNaN(id));
      this.FormValid.get('objectname')?.setValue(selectedIds);
    }
    });
      }
      console.log(this.data)
      this.backgroundColorButton = this.localstorage.getSettings('ColorA');
     
      
      // this.FormValid.get('mappingtypename')?.setValue(this.mappingtypename);
      this.formValidationsCheckbox();

    }
    cancel(){
      this.dialogRef.close();
    }
  
     formValidationsCheckbox() {
  this.formValidCheckbox = new UntypedFormGroup({
    isCheckboxSelected: new UntypedFormControl(false)
  });
}

    formvalidations(){
      this.FormValid = new FormGroup({
        'sqlscript__j' : new FormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
        'queryexecutiontype__j':new FormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
        'sourceconnectionstring__j': new FormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
        'sourcetype__j':new FormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
        'filename__j':new FormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
        'executionorder__j':new FormControl('',[Validators.required,Validators.pattern('^[1-9][0-9]*$')]),
        'attachmentquery__j':new FormControl('',[Validators.required]),
        'extractiontype__j': new FormControl('',[Validators.required]),
        'isExecutable__j': new FormControl('',[Validators.required]),
        'objectgroupname':new FormControl('',[Validators.required]),
        'setssplitrequired': new FormControl('',[Validators.required]),
        'groupextractiontype':new FormControl('',[Validators.required]),
        'automatically_formate':new FormControl('',[Validators.required]),
        'formated_sqlscript__j':new FormControl(''),
        'objectname': new FormControl('',[Validators.required])
       })
    }
  
    saveMethod(){
      if(!this.FormValid.valid ){
        this.FormValid.markAllAsTouched();
        //  const message = this.FormValid.pristine
        //   ? 'Please fill out the required fields before submitting.'
        //   : 'Please correct the highlighted validation errors before submitting.';
            this.snackbar.open("All mandatory fields to be filled","ok",{duration:3000});
            return
        }
      // console.log(this.functional)
      // const formdata = this.functional
      console.log('Saving Data:', this.FormValid.value.mappingtypename);
      var dnsid = localStorage.getItem('dnsName');
      if(this.buttonName == 'Update'){
       this.idColumn =  this.sqlscripts__j.sqlscriptid__j ;
      }else{
        this.idColumn = 0;
      }
      const requestData = {
        sqlscript__j: this.sqlscripts__j.sqlscript__j,// Adjust based on API field names
        tenantid : dnsid,
        sqlscriptid__j: this.idColumn,
        queryexecutiontype__j:this.sqlscripts__j.queryexecutiontype__j,
        sourceconnectionstring__j:this.sqlscripts__j.sourceconnectionstring__j,
        sourcetype__j:this.sqlscripts__j.sourcetype__j,
        filename__j:this.sqlscripts__j.filename__j,
        executionorder__j:this.sqlscripts__j.executionorder__j,
        attachmentquery__j:this.sqlscripts__j.attachmentquery__j,
        extractiontype__j:this.sqlscripts__j.extractiontype__j,
        isExecutable__j:this.sqlscripts__j.isExecutable__j,
        objectgroupname:this.sqlscripts__j.objectgroupname,
        setssplitrequired:this.sqlscripts__j.setssplitrequired,
        groupextractiontype:this.sqlscripts__j.groupextractiontype,
        automatically_formate:this.sqlscripts__j.automatically_formate,
        formated_sqlscript__j:this.sqlscripts__j.formated_sqlscript__j,
        objectname:this.sqlscripts__j.objectname,
        objectgroupid:this.sqlscripts__j.objectgroupid
        
      };
      this.spinner.start();
      this.commonservice.saveSourceDataExtractionQueries(requestData).subscribe({
        next: (response) => {
          if(response.error === true){
            this.snackbar.open(response.statusMessage, 'OK', { duration: 3000 });
            this.spinner.stop();
            return
          }
          console.log('edit successful', response);
          console.log(response.data)
          this.updatedData = null;
          this.snackbar.open(response.statusMessage, 'OK', { duration: 3000 });
          if (this.isCheckboxSelected && this.buttonName === 'Save') {
          this.FormValid.reset();
         this.sqlscripts__j.sqlscript__j = '',
         this.sqlscripts__j.queryexecutiontype__j = '',
         this.sqlscripts__j.sqlscriptid__j = '',
         this.sqlscripts__j.sourceconnectionstring__j = '',
         this.sqlscripts__j.sourcetype__j = '',
         this.sqlscripts__j.filename__j = '',
         this.sqlscripts__j.executionorder__j = '',
         this.sqlscripts__j.attachmentquery__j = '',
         this.sqlscripts__j.extractiontype__j = '',
         this.sqlscripts__j.isExecutable__j = '',
         this.sqlscripts__j.objectgroupname = '',
         this.sqlscripts__j.setssplitrequired = '',
         this.sqlscripts__j.groupextractiontype = '',
         this.sqlscripts__j.automatically_formate = '',
         this.sqlscripts__j.objectgroupname = '',
         this.sqlscripts__j.objectgroupid = ''
          this.buttonName = 'Save';
        } else {
          this.dialogRef.close(response.data);
        }
        },
        error: (error: any) => {
          console.error('retrieve failed', error);
           this.spinner.stop();
        },
        complete: () => {
          console.log('retrieve  completed');
          this.updatedData = null
           this.spinner.stop();
        }
      });
    }
    getObjectGroup$() {
  this.spinner.start();
  this.vaultObjectService
    .retrieveAllobjectgroup(this.localstorage.getSettings("dnsName"), "Extraction Group")
    .subscribe({
      next: (res) => {
        console.log(res)
        this.objectGroupData = res.filter((obj:any)=> obj.status==='Yes') || [];
        console.log(this.objectGroupData)
        this.spinner.stop();
      },
      error: (err) => {
        console.error(err);
        this.spinner.stop();
      }
    });
}

      onObjectGroupChange(event){
                this.spinner.start();
                console.log(event);
                  const selected = event.value;
                  console.log("Selected Group:", selected);
                console.log(event.value.objectGroupId)
                this.sqlscripts__j.objectgroupid=event.value
                let objectGroupName=this.objectGroupData.filter(item=>item.objectGroupId == event.value)[0].objectGroupName;
                this.sqlscripts__j.objectgroupname=objectGroupName;
                console.log(objectGroupName);
               
               const dnsId=this.localstorage.getSettings("dnsName")
              this.commonservice.retrieveObjectsBasedOnObjectGroupNameBasedOnTenantId(dnsId,this.sqlscripts__j.objectgroupname).subscribe((res:any)=>{
              console.log(res);
              if(res.error == true){
                        // this.spinner.stop();
                        // this.listOfObjectsWithGroup=[]
                        this.snackbar.open(res.statusMessage, "OK", {
                          duration: 5000,
                        });
                      }else{
                        // this.listOfObjectsWithGroup=res
                        console.log(res);
                         this.ObjectsData = res.filter((obj:any)=> obj.status==='Yes');
                        console.log(this.ObjectsData)
                        const objects = res.map((item: any, index: number) => ({
                            id: item.id || index, // Assign index if id is missing
                            objectlabel: item.objectlabel || item,
                            objectname:item.objectname||item
                        }));
    
                        console.log("Mapped Objects for Grid:", objects);
                        // this.ObjectGrid.api.setGridOption('rowData', objects);
                        // this.paramstemp.api.setGridOption('rowData', []);
                      }
              
              // this.cdr.detectChanges();
              // this.refreshGridData();
              this.spinner.stop();
            })
            }

    onObjectNameChange(event: any) {
  // event.value is an array of selected IDs
      console.log('Selected Object IDs:', event.value);
  // Convert to JSON string for DB storage
     this.sqlscripts__j.objectname = JSON.stringify(event.value);
  }
  onQueryExecutionChange(event: any){
     console.log('Selected query executiontype:', event.value);
    this.sqlscripts__j.queryexecutiontype__j = event.value;
  }

  onDataSourceChange(event: any){
     console.log('Selected Data Source:', event.value);
    this.sqlscripts__j.sourceconnectionstring__j = event.value;
  }
}



